var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"my-3 base-body-text"},[_vm._v(_vm._s(_vm.designation))])}
var staticRenderFns = []

export { render, staticRenderFns }